import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { closeItemNoteModal, openItemNoteModal, orderItemnoteAdd, modalReset } from '../actions/index';
import { Modal } from 'react-bootstrap';

class ModalItemNote extends Component {
  constructor(props) {
    super(props);

    this.state = {
      itemNote: '',
    }
  }

  // When someone clicks on the mod button, the props will change so use
  // here to pre-populate the message with the stored value
  componentWillReceiveProps(nextProps) {
    if (this.props.modals.modalCurrentOrderItemID !== '') {
      this.setState({ itemNote: this.props.current_order.items[this.props.modals.modalCurrentOrderItemID].note });
    }
  }

  // Handle the user changing the note text
  handleItemNoteChange = note => {
    this.setState({ itemNote: note });
  }

  // Add a note to a specific order item
  handleAddItemNote = () => {
    this.props.orderItemnoteAdd(this.props.modals.modalCurrentOrderItemID, this.state.itemNote);
    this.props.closeItemNoteModal();
    this.props.modalReset();
  }

  render() {
    return(
      <Modal show={this.props.modals.showItemNoteModal} onHide={this.props.closeItemNoteModal}>
        <Modal.Header closeButton>
          <Modal.Title>Enter Item Note</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="form-group">
              <textarea autoFocus className="form-control" onChange={event => this.handleItemNoteChange(event.target.value)} value={this.state.itemNote}></textarea>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-secondary" onClick={this.props.closeItemNoteModal}>Close</button>&nbsp;
          <button type="button" className="btn btn-primary" onClick={this.handleAddItemNote}>Save Changes</button>
        </Modal.Footer>
      </Modal>
    );
  }
}

function mapStateToProps({ modals, current_order }) {
  return { modals, current_order };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators( { closeItemNoteModal, openItemNoteModal, orderItemnoteAdd, modalReset }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalItemNote);



// WEBPACK FOOTER //
// ./src/containers/modal_item_note.js